import { refresh as fetchSettings } from '$store/settings'

fetchSettings()
